import { ReactNode } from "react";
import "./FormSection.scss";

export interface FormSectionProps {
  children: ReactNode;
  width?: "sm" | "md" | "lg";
  className?: string;
}

function FormSection({ className, children, width = "md" }: FormSectionProps) {
  const widthClass = `form-section-${width}`;
  return <div className={`form-section-container ${widthClass} ${className}`}>{children}</div>;
}

FormSection.defaultProps = {
  width: "md" as "md",
  className: "",
};

export default FormSection;
